import React, { useState } from "react";
import { Modal, Form, Input, Button, Typography } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
const { Paragraph } = Typography;

const OTPModal = ({ otpModal, setOtpModal, openReset, email }) => {

    const { request }   = useRequest();
    const [form]        = Form.useForm();
    const [verifyLoading, setVerifyLoading] = useState(false);

    const handleVerifyOTP = async (values) => {
        setVerifyLoading(true);

        try {
            const payload = { otp: values.otp, email };

            await request({
                url: apiPath.verifyOTP,
                method: "POST",
                data: payload,
                onSuccess: (data) => {
                    setVerifyLoading(false);
                    ShowToast(data.message, Severty.SUCCESS);
                    setOtpModal(false);
                    openReset(true);
                },
                onError: (error) => {
                    setVerifyLoading(false);
                    ShowToast(error?.response?.data?.message, Severty.ERROR);
                },
            });
        } catch (err) {
            setVerifyLoading(false);
            ShowToast(err.message, Severty.ERROR);
        }
    };

    return (
        <Modal
            open={otpModal}
            title={null}
            onCancel={() => setOtpModal(false)}
            footer={null}
            destroyOnHidden
            centered
            className="p-0"
        >
            <div className="p-4 md:p-4 w-full max-w-md mx-auto">

                <div className="flex flex-col items-center mb-4">
                    <div className="bg-[#94C13E] text-white rounded-full p-4 mb-2">
                        <LockOutlined className="text-2xl" />
                    </div>

                    <h2 className="text-xl font-semibold text-gray-800">Verify OTP</h2>
                    <Paragraph className="text-center text-gray-600 mt-2 text-sm">
                        We have sent a <strong>4-digit OTP</strong> to your email <span className="font-medium">{email}</span>. Please enter it below to verify your account.
                    </Paragraph>
                </div>

                <Form form={form} layout="vertical" onFinish={handleVerifyOTP}>
                    <Form.Item
                        label="OTP"
                        name="otp"
                        rules={[
                            { required: true, message: "Enter OTP!" },
                            { len: 4, message: "OTP must be 4 digits!" },
                        ]}
                    >
                        <Input
                            type="number"
                            maxLength={4}
                            placeholder="Enter OTP"
                            className="rounded-md border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/50"
                        />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={verifyLoading}
                        className="w-full bg-[#94C13E] hover:bg-[#82b32e] text-white font-medium py-2 rounded-md transition duration-200"
                    >
                        Verify OTP
                    </Button>
                </Form>
            </div>
        </Modal>
    );
};

export default OTPModal;

